<template lang="html">
  <div class="md-layout md-alignment-center-space-around">

    <md-card md-with-hover>
      <md-ripple>
        <md-card-header>
          <div class="md-title">Login to Team Texting</div>
          <div class="md-subhead">If you need an account, <router-link to='/signup'>Sign up!</router-link></div>
        </md-card-header>

        <md-card-content>
          <form action="index.html">
            <md-field>
              <label><md-icon>email</md-icon>Email Address</label>
              <md-input v-model="email" @keyup.enter="login"></md-input>
            </md-field>
            <md-field>
              <label><md-icon>lock</md-icon>Password</label>
              <md-input type="password" v-model="password" @keyup.enter="login"></md-input>
            </md-field>
          </form>
        </md-card-content>

        <md-card-actions>
          <md-button v-on:click="login" class="md-primary">Login</md-button>
        </md-card-actions>
      </md-ripple>
    </md-card>
    <md-snackbar :md-active.sync="showSnackbar">
      <span>{{ this.errormessage }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'login',
  data: function () {
    return {
      email: '',
      password: '',
      errormessage: '',
      showSnackbar: false
    }
  },
  methods: {
    login: function (e) {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            // alert(`You are logged in as ${user.email}`)
            this.$router.go({ path: this.$router.path })
          },
          err => {
            this.errormessage = err.message
            this.showSnackbar = true
          }
        )
      e.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-card {
    width: 320px;
    margin: 15vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue